/**
 * app相关公共公共方法
 */

const UA = window.navigator.userAgent;

export const isAndroid = /android/i.test(UA);
export const isiOS = /iphone|ipad/i.test(UA);

export const isInAllApp =
  /HLLPorterApp/.test(UA) || // 搬家小哥
  /com\.xiaolachuxing/.test(UA); // 用户 司机 企业

export const isInEnterpriseApp = /com\.xiaolachuxing/.test(UA);

/**
 * 异步加载脚本
 * @param {string} url 脚本地址
 * @param {function} onloaded 加载完成的回调
 * @param {function} onerror 加载错误的回调
 */
export const loadScript = (url, onloaded = null, onerror = null) => {
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  if (onloaded && typeof onloaded === 'function') {
    script.addEventListener('load', onloaded);
  }
  if (onerror && typeof onerror === 'function') {
    script.addEventListener('error', onerror);
  }
  document.body.append(script);
};
